document.addEventListener(
  'DOMContentLoaded',
  () => {

    /*
    |--------------------------------------------------------------------------
    | CUSTOMER REQUIRED
    |--------------------------------------------------------------------------
    */

    if (!window.artistCustomer) {
      return;
    }

    /*
    |--------------------------------------------------------------------------
    | CUSTOMER DATA
    |--------------------------------------------------------------------------
    */

    const customerTier =
      window.artistCustomer.tier;

    const benefitUsed =
      window.artistCustomer.benefitUsed;

    /*
    |--------------------------------------------------------------------------
    | ALL TIERS
    |--------------------------------------------------------------------------
    */

    const TIER_LIMITS = {

      '1a': {
        credits: 10,
        primer: 1,
        hydra: 1,
        wrap: 1
      },

      '1b': {
        credits: 10,
        primer: 1,
        hydra: 1,
        wrap: 1
      },

      '2a': {
        credits: 6,
        primer: 1,
        hydra: 1,
        wrap: 1
      },

      '2b': {
        credits: 12,
        primer: 2,
        hydra: 2,
        wrap: 2
      }

    };

    /*
    |--------------------------------------------------------------------------
    | CURRENT LIMITS
    |--------------------------------------------------------------------------
    */

    const LIMITS =
      TIER_LIMITS[customerTier];

    /*
    |--------------------------------------------------------------------------
    | INVALID CUSTOMER
    |--------------------------------------------------------------------------
    */

    if (
      !LIMITS ||
      benefitUsed === true ||
      benefitUsed === 'true'
    ) {
      return;
    }

    /*
    |--------------------------------------------------------------------------
    | LOCK
    |--------------------------------------------------------------------------
    */

    let processing = false;

    /*
    |--------------------------------------------------------------------------
    | NOTICE
    |--------------------------------------------------------------------------
    */

    function showNotice(message) {

      let existing =
        document.querySelector(
          '.artist-tier-notice'
        );

      if (existing) {
        existing.remove();
      }

      const notice =
        document.createElement('div');

      notice.className =
        'artist-tier-notice';

      notice.style.background =
        '#000';

      notice.style.color =
        '#fff';

      notice.style.padding =
        '14px';

      notice.style.marginBottom =
        '15px';

      notice.style.borderRadius =
        '8px';

      notice.style.fontSize =
        '14px';

      notice.innerHTML =
        message;

      const cartForm =
        document.querySelector(
          'form[action="/cart"]'
        );

      if (cartForm) {

        cartForm.prepend(notice);

      }

    }

    /*
    |--------------------------------------------------------------------------
    | REFRESH QTY
    |--------------------------------------------------------------------------
    */

    function refreshQtyAttributes() {

      const rows =
        document.querySelectorAll(
          '.cart-item'
        );

      rows.forEach(row => {

        const artistItem =
          row.querySelector(
            '.artist-cart-item'
          );

        if (!artistItem) {
          return;
        }

        const qtyInput =
          row.querySelector(
            '.cart-item__quantity-input'
          );

        if (!qtyInput) {
          return;
        }

        artistItem.dataset.qty =
          qtyInput.value;

      });

    }

    /*
    |--------------------------------------------------------------------------
    | ADD PAID PRODUCT
    |--------------------------------------------------------------------------
    */

    async function addPaidProduct(
      variantId,
      qty
    ) {

      return fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type':
            'application/json'
        },

        body: JSON.stringify({

          id: variantId,

          quantity: qty

        })

      });

    }

    /*
    |--------------------------------------------------------------------------
    | UPDATE CART ITEM
    |--------------------------------------------------------------------------
    */

    async function updateCartItem(
      key,
      qty
    ) {

      return fetch('/cart/change.js', {

        method: 'POST',

        headers: {
          'Content-Type':
            'application/json'
        },

        body: JSON.stringify({

          id: key,

          quantity: qty

        })

      });

    }

    /*
    |--------------------------------------------------------------------------
    | PROCESS CART
    |--------------------------------------------------------------------------
    */

    async function processArtistCart() {

      if (processing) {
        return;
      }

      processing = true;

      refreshQtyAttributes();

      const cartItems =
        document.querySelectorAll(
          '.artist-cart-item'
        );

      if (!cartItems.length) {

        processing = false;

        return;

      }

      let usedCredits = 0;

      let cartChanged = false;

      /*
      |--------------------------------------------------------------------------
      | LOOP ITEMS
      |--------------------------------------------------------------------------
      */

      for (const item of cartItems) {

        const key =
          item.dataset.key;

        const qty =
          parseInt(
            item.dataset.qty || 0
          );

        const tags =
          (item.dataset.tags || '')
            .split(',')
            .map(tag =>
              tag.trim()
            );

        const paidVariantId =
          item.dataset.paidVariant;

        /*
        |--------------------------------------------------------------------------
        | PRODUCT TYPES
        |--------------------------------------------------------------------------
        */

        const isSignature =
          tags.includes(
            'artist-signature'
          );

        const isTraditional =
          tags.includes(
            'artist-traditional'
          );

        /*
        |--------------------------------------------------------------------------
        | CREDIT VALUE
        |--------------------------------------------------------------------------
        */

        let creditValue = 0;

        if (isSignature) {
          creditValue = 1;
        }

        if (isTraditional) {
          creditValue = 2;
        }

        /*
        |--------------------------------------------------------------------------
        | NOT ARTIST PRODUCT
        |--------------------------------------------------------------------------
        */

        if (!creditValue) {
          continue;
        }

        /*
        |--------------------------------------------------------------------------
        | CALCULATE ALLOWED QTY
        |--------------------------------------------------------------------------
        */

        let allowedQty = 0;

        for (
          let i = 0;
          i < qty;
          i++
        ) {

          if (
            usedCredits + creditValue <=
            LIMITS.credits
          ) {

            usedCredits +=
              creditValue;

            allowedQty++;

          }

        }

        /*
        |--------------------------------------------------------------------------
        | OVERFLOW
        |--------------------------------------------------------------------------
        */

        if (allowedQty < qty) {

          const overflowQty =
            qty - allowedQty;

          /*
          |--------------------------------------------------------------------------
          | UPDATE ARTIST PRODUCT
          |--------------------------------------------------------------------------
          */

          await updateCartItem(
            key,
            allowedQty
          );

          /*
          |--------------------------------------------------------------------------
          | ADD HIDDEN PAID PRODUCT
          |--------------------------------------------------------------------------
          */

          if (
            paidVariantId &&
            overflowQty > 0
          ) {

            await addPaidProduct(
              paidVariantId,
              overflowQty
            );

          }

          cartChanged = true;

        }

      }

      /*
      |--------------------------------------------------------------------------
      | NOTICE
      |--------------------------------------------------------------------------
      */

      if (cartChanged) {

        showNotice(
          'Artist limit exceeded. Extra quantities were automatically converted to regular priced products.'
        );

        setTimeout(() => {

          window.location.reload();

        }, 500);

      }

      processing = false;

    }

    /*
    |--------------------------------------------------------------------------
    | INITIAL
    |--------------------------------------------------------------------------
    */

    processArtistCart();

    /*
    |--------------------------------------------------------------------------
    | BUTTON WATCH
    |--------------------------------------------------------------------------
    */

    document.body.addEventListener(
      'click',
      (event) => {

        const quantityButton =
          event.target.closest(
            '.quantity-up, .quantity-down'
          );

        if (!quantityButton) {
          return;
        }

        clearTimeout(
          window.artistQtyTimer
        );

        window.artistQtyTimer =
          setTimeout(() => {

            processArtistCart();

          }, 400);

      }
    );

    /*
    |--------------------------------------------------------------------------
    | INPUT WATCH
    |--------------------------------------------------------------------------
    */

    document.body.addEventListener(
      'change',
      (event) => {

        const qtyInput =
          event.target.closest(
            '.cart-item__quantity-input'
          );

        if (!qtyInput) {
          return;
        }

        clearTimeout(
          window.artistQtyTimer
        );

        window.artistQtyTimer =
          setTimeout(() => {

            processArtistCart();

          }, 500);

      }
    );

  }
);